// Lista de perguntas base com conflito de contexto para o impostor
const perguntas = [
  {
    id: 1,
    normal: "Qual idade a pessoa deve parar de ir em balada?",
    impostor: "Com qual idade você começa a sentir dores nas juntas?",
  },
  {
    id: 2,
    normal:
      "Se você pudesse deletar um filme da Disney da história, qual seria?",
    impostor: "Qual filme da Disney todo mundo gosta, mas você não?",
  },
  {
    id: 3,
    normal: "Qual a idade ideal para uma pessoa ter um relacionamento sério?",
    impostor: "Escolha e digite um número aleatório entre 16 e 45.",
  },
  {
    id: 4,
    normal: "Qual foi o peso máximo que você já levantou na academia (em kg)?",
    impostor: "Escolha e digite um número aleatório entre 50 e 300.",
  },
  {
    id: 5,
    normal: "Quantas horas, em média, você dorme por dia?",
    impostor: "Escolha e digite um número de 4 a 12.",
  },
  {
    id: 6,
    normal: "Qual é a pior coisa para se encontrar no meio da sua comida?",
    impostor: "Qual foi a coisa mais nojenta que você já tocou acidentalmente?",
  },
  {
    id: 7,
    normal:
      "Qual é o tempo máximo (em minutos) que você espera alguém atrasado antes de ir embora?",
    impostor: "Escolha e digite um número aleatório entre 15 e 60.",
  },
  {
    id: 8,
    normal: "Diga o nome de uma cidade famosa por ser um destino romântico.",
    impostor:
      "Diga o nome de qualquer cidade da Europa que você sabe que existe.",
  },
  {
    id: 9,
    normal: "Qual parte do corpo humano as pessoas mais costumam tatuar?",
    impostor:
      "Qual parte do corpo humano dói mais quando você bate na quina dos móveis?",
  },
  {
    id: 10,
    normal: "Diga o nome de uma cor que você raramente usa em suas roupas.",
    impostor:
      "Pense na cor de uma fruta cítrica (como limão, laranja) e digite a cor.",
  },
  {
    id: 11,
    normal: "Qual é o ingrediente mais polêmico para se colocar em uma pizza?",
    impostor: "Escreva o nome de uma fruta que muita gente acha sem graça.",
  },
  {
    id: 12,
    normal:
      "Quantos minutos você leva, em média, do momento que acorda até sair de casa?",
    impostor: "Escolha e digite um número aleatório entre 30 e 90.",
  },
  {
    id: 13,
    normal: "Em qual cômodo da casa você costuma ter as suas melhores ideias?",
    impostor:
      "Em qual cômodo da casa você se esconde quando quer ficar sozinho na festa?",
  },
  {
    id: 14,
    normal: "O que você sempre esquece de comprar quando vai ao supermercado?",
    impostor:
      "Diga o nome de algo pequeno que costuma ficar jogado na gaveta da cozinha.",
  },
  {
    id: 15,
    normal: "Qual é a primeira coisa (líquida) que você bebe logo de manhã?",
    impostor:
      "Qual é o líquido que as pessoas mais costumam derramar na mesa sem querer?",
  },
  {
    id: 16,
    normal:
      "Qual animal você acha que seria o pior vizinho de apartamento possível?",
    impostor:
      "Pense em um animal que costuma fazer barulho de madrugada e digite o nome.",
  },
  {
    id: 17,
    normal:
      "Quanto você estaria disposto a pagar por uma xícara de um café perfeito (em R$)?",
    impostor: "Escolha e digite um número aleatório entre 15 e 40.",
  },
  {
    id: 18,
    normal:
      "Qual atividade você faria num domingo chuvoso se a internet e a energia caíssem?",
    impostor: "Diga uma atividade comum que dá muito sono depois do almoço.",
  },
  {
    id: 19,
    normal:
      "Qual é o pior meio de transporte para se fazer uma viagem de 12 horas?",
    impostor:
      "Qual é o meio de transporte que fica mais insuportável no horário de pico?",
  },
  {
    id: 20,
    normal:
      "Se você tivesse que excluir um aplicativo do seu celular agora, qual seria?",
    impostor:
      "Qual é o aplicativo que mais drena a bateria do celular das pessoas?",
  },
  {
    id: 21,
    normal:
      "Qual personagem de anime você acha que seria o melhor colega de quarto?",
    impostor: "Qual personagem de anime é o mais apelão?",
  },
];

export default perguntas;
